import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'unistore/react';

import { trackEvent } from '~/Utils';
import actions from '~/state/Actions';

import IWLogo from './Assets/iw-logo.svg';

const FooterWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AdditionalLink = styled.div`
  font-size: 12px;
  color: black;
  text-align: right;

  a,
  span {
    color: black;
    text-decoration: underline;
    cursor: pointer;
  }
`;

class Footer extends PureComponent {
  render() {
    return (
      <FooterWrapper>
        <a target="_blank" href={config.logoLink}>
          <IWLogo onClick={() => trackEvent('logo_click')} width={30} height={26} />
        </a>
        <div>
          {/* <AdditionalLink onClick={() => trackEvent('study_click')}>Zur <a target="_blank" href={config.studyLink}>Studie</a></AdditionalLink> */}
          <AdditionalLink onClick={() => trackEvent('info_click')}>
            Definitionen und Hintergrundinformationen unter{' '}
            <span onClick={() => this.props.setInfoboxContent('faq')}>Info</span>
          </AdditionalLink>
        </div>
      </FooterWrapper>
    );
  }
}

export default connect(null, actions)(Footer);
